import { useSelector } from 'react-redux';

import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Typography,
} from '@mui/material';

import { PrimaryButton } from 'src/components/common/buttons/PrimaryButton';
import { IConfirmationModalProps } from 'src/components/common/types/modalTypes';

export const ConfirmationModal: React.FC<IConfirmationModalProps> = ({
	title,
	modalOpen,
	handleModalCLose,
	modalContent,
	handleYes,
	handleNo,
	loadingKey,
	modalYesBtnTitle = 'YES',
	modalNoBtnTitle = 'NO',
	color,
	width,
}) => {
	const isLoading = useSelector((state: { loading: ILoadingState }) =>
		loadingKey ? (state.loading.loadingStates[loadingKey] ?? false) : false,
	);

	if (!modalOpen) return null;

	return (
		<Dialog
			PaperProps={{
				sx: { borderRadius: 1, width: width || '450px', padding: 1 },
			}}
			open={modalOpen}
			onClose={handleModalCLose ? handleModalCLose : handleNo}
		>
			<DialogContent>
				<Typography fontSize={'18px'}>{title}</Typography>
				<Box
					sx={{
						borderColor: color ? color : 'red',
						borderRadius: 1,
						borderStyle: 'dashed',
						borderWidth: '1px',
						padding: 1,
						marginTop: 2,
						backgroundColor: color ? '#00000' : '#fdf7f7',
						alignSelf: 'center',
						textAlign: 'center',
					}}
				>
					<Typography color='text.secondary' fontSize={'12px'}>
						{modalContent}
					</Typography>
				</Box>
			</DialogContent>
			<DialogActions>
				<PrimaryButton
					onClick={handleNo}
					disabled={isLoading}
					fullWidth={false}
					size='medium'
				>
					{modalNoBtnTitle}
				</PrimaryButton>
				<Button
					onClick={handleYes}
					color={color ? 'success' : 'error'}
					variant='outlined'
					disabled={isLoading}
				>
					{modalYesBtnTitle}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
